import { render } from "./NewVew.vue?vue&type=template&id=7016e431"
import script from "./NewVew.vue?vue&type=script&lang=js"
export * from "./NewVew.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__